import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PlusIcon } from "lucide-react";
import { Section, SectionHeading } from "./Section";
import { CTAButton } from "./CTAButton";
import { faqs } from "../data/faqs";
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <Section tone="light" data-id="element-107" data-mp="1cg1jdsu5ifb1">
      <SectionHeading eyebrow="Frequently asked questions" title="Everything You Need to Know Before Purchasing" data-id="element-108" data-mp="1ccnfgg5u9y1h" />

      <div className="mx-auto mt-10 max-w-3xl divide-y divide-navy-900/10 border-y border-navy-900/10" data-id="element-109" data-mp="253f5sx083sgw">
        {faqs.map((f, i) => {
        const isOpen = open === i;
        return <div key={f.q} data-id="element-110" data-mp="1v4zpzq6nc5mp" data-mpi={i}>
              <h3 data-id="element-111" data-mp="1v5r9i2myycwm">
                <button type="button" aria-expanded={isOpen} aria-controls={`faq-${i}`} onClick={() => setOpen(isOpen ? null : i)} className="flex w-full items-start justify-between gap-4 py-5 text-left text-[17px] font-bold text-navy-900 focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-400 md:text-lg" data-id="element-112" data-mp="1v46iuo3rze41">
                  <span data-id="element-113" data-mp="1pkqmtne9caqw">
                    <span className="mr-2 text-gold-700" data-id="element-114" data-mp="1apsuguj3zl9t">{i + 1}.</span>
                    {f.q}
                  </span>
                  <PlusIcon className={`mt-0.5 h-6 w-6 shrink-0 text-navy-900/60 transition-transform duration-200 ease-out ${isOpen ? "rotate-45" : ""}`} aria-hidden data-id="element-115" data-mp="1fnudxgkg5mlt" />
                </button>
              </h3>
              <AnimatePresence initial={false} data-id="element-116" data-mp="rz2v3fsqyglp">
                {isOpen && <motion.div id={`faq-${i}`} initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: "auto",
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.22,
              ease: [0.23, 1, 0.32, 1]
            }} className="overflow-hidden" data-id="element-117" data-mp="rwyhg651q388">
                    <div className="space-y-3 pb-6 text-[16px] leading-relaxed text-navy-900/75" data-id="element-118" data-mp="2pny5vommwpnk">
                      {f.a.map(p => <p key={p} data-id="element-119" data-mp="2fwkbfv9jig1a">{p}</p>)}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>;
      })}
      </div>

      <CTAButton label="I’m ready — get the complete collection" note="One-time payment · $27 USD · Digital product" data-id="element-120" data-mp="38lrbwzsk1fp6" />
    </Section>;
}